import { render, staticRenderFns } from "./AnnotationTaskUpload.vue?vue&type=template&id=0d7fe5f9&"
import script from "./AnnotationTaskUpload.vue?vue&type=script&lang=js&"
export * from "./AnnotationTaskUpload.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationTaskUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports